import type { App } from 'vue';
import route, { type RouteFunction } from './route';
import type * as FunctionsType from './functions';
import * as functions from './functions';
import type * as TestType from './test';
import * as test from './test';
import type * as DigitType from './digit';
import * as digit from './digit';

export type uToolsType = typeof FunctionsType & typeof DigitType & { test: typeof TestType; route: RouteFunction };

const utils: uToolsType = {
  ...functions,
  ...digit,
  test,
  route,
};

uni.$u = utils;

export const uTools = {
  install(app: App<Element>) {
    app.config.globalProperties.$u = utils; // 挂在到全局属性，方便在模板中直接使用
  },
};

export { functions };
